/* tslint:disable */
/* eslint-disable */

/**
 * 805290000 = Institution (Institution)
 * 
 * 805290001 = Kontakt (Kontakt)
 */
import {EnumValue} from "@/core/models/enumvalue.model"
import { marker } from '@biesbjerg/ngx-translate-extract-marker';

export enum GlobalEnumsAceAntragstellungerfolgtfuer {
 Institution = 805290000,
 Kontakt = 805290001
}

marker([
    "Enum.GlobalEnumsAceAntragstellungerfolgtfuer.Institution",
    "Enum.GlobalEnumsAceAntragstellungerfolgtfuer.Kontakt"
]);

export namespace GlobalEnumsAceAntragstellungerfolgtfuer
{
    class DataSets
    {
        static GlobalEnumsAceAntragstellungerfolgtfuerDataSet: Array<EnumValue> = new Array<EnumValue>(
            new EnumValue("Institution", 805290000, "Institution"),
            new EnumValue("Kontakt", 805290001, "Kontakt"),
        )
    }

    export function getAsDataset() {
        return DataSets.GlobalEnumsAceAntragstellungerfolgtfuerDataSet;
    }
}
